import React from 'react';
import './candidateHeaderSection.css';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../../../homepage/registerflow/registerflow';
import { useState } from 'react';

const CandidateHeaderSection = () => {
    const navigate = useNavigate();
    const handleJoinClick = () => {
        navigate('/login');
    };
    const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

    const openRegisterPopup = () => {
        setRegisterPopupVisible(true);
    };

    const closeRegisterPopup = () => {
        setRegisterPopupVisible(false);
    };
    return (
        <div className="fluid-container">
            <div className="hero-container">
                <div className="content-wrapper">
                    <h1 className="cand-headline">Find Your Next</h1>
                    <h1 className="cand-headline-simplified">LEADERSHIP OPPORTUNITY</h1>
                    <h6 className="subheadline">
                        <span>India's 1<sup>st</sup>&nbsp;</span> Exclusive Platform for Senior Leadership Recruitment
                    </h6>
                    <div className="left-button-container">
                        <button className="left-button" onClick={openRegisterPopup}>Join Now</button>
                    </div>
                </div>
            </div>
            <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
        </div>
    );
};


export default CandidateHeaderSection;